import React, { useContext, useEffect, useMemo } from 'react';
import AdminOtherActionsContainer from 'containers/protocol/administration/AdminOtherActionsContainer';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { bindLogger } from 'helpers/BindLogger';
import { AppContext } from '@ctsu/loader';
import AdminDtlAndExclusions from './adminFlags/AdminDtlAndExclusions';
import { getAdminInfoAction } from '../../../actions/protocols/admin';
import { getAdminInfoSelector } from '../../../reducers/protocols/admin/adminReducer';
import StatusChange from './statuschange';
import StatusTransaction from './statustransaction';

const EmptyDivider = () => <div style={{ height: '.5rem' }} />

const AdminScreen = () => {
  const dispatch = useDispatch();
  const actions = useMemo(() => bindActionCreators({
    getAdminInfoAction
  }, dispatch), [dispatch]);
  const context = useContext(AppContext);
  const { protocolNumber, phase } = useSelector(state => state.prtDetails.prtInfo);
  const adminInfo = useSelector(getAdminInfoSelector);

  useEffect(() => {
    if (protocolNumber) {
      bindLogger(actions.getAdminInfoAction, context)(protocolNumber);
    }
  }, [actions, context, protocolNumber]);

  const isMultiPhase = useMemo(() => {
    if (phase && phase.includes('/')) {
      return phase.includes('/');
    }
    return false;
  }, [phase]);

  return <div className="d-flex row text-align-left">
    <div data-testid='admin-container' className="col-6 mr-2">
      {adminInfo ? <>
        <AdminDtlAndExclusions />
        <EmptyDivider />
      </> : null}
    </div>
    <div className="col-6 ml-2">
      <AdminOtherActionsContainer />
      <StatusChange multiPhase={isMultiPhase} />
      <StatusTransaction multiPhase={isMultiPhase} />
    </div>
  </div>
};

export default AdminScreen;